import { Component, OnInit, Input, ElementRef, AfterViewChecked, ViewChild } from '@angular/core';
import { Dayjs } from 'dayjs';
import * as moment from 'moment-timezone';

@Component({
  selector: 'app-dialog-timezone',
  templateUrl: './dialog-timezone.component.html',
  styleUrls: ['./dialog-timezone.component.scss']
})
export class DialogTimezoneComponent implements OnInit, AfterViewChecked {

  public eventTimeZoneIsDefined: boolean = false;
  @Input() fontSet: string = 'jems3r';
  @Input() public date: Dayjs;
  @Input() public eventTimeZone: string;
  public displayedColumns: string[] = ['name', 'time'];
  public timeZones: string[];
  
  @ViewChild('timeTzSpan') timeTzSpan: ElementRef;
  private lastPrefixText: string | undefined = undefined;

  constructor(private el: ElementRef) { }

  ngOnInit(): void {
    const browserTimeZone = moment.tz.guess(true); // Get user browser's timeZone
    const gmt0_timezone   = 'Greenwich';           // Get GMT-O
    const edt_timezone    = 'America/New_York';    // EDT timeZone

    this.timeZones = [browserTimeZone, gmt0_timezone];
    if (this.eventTimeZone && !this.timeZones.includes(this.eventTimeZone)) {
      this.timeZones.splice(1, 0, this.eventTimeZone); // Add Event's TimeZone if defined.
      this.eventTimeZoneIsDefined = true;
    }
    if (this.eventTimeZone !== edt_timezone) {
      this.timeZones.push(edt_timezone);
    }
  }

  ngAfterViewChecked(): void {
    const prevNode = this.el.nativeElement.previousSibling;
    if (prevNode && prevNode.nodeType === Node.TEXT_NODE) {
      const text = prevNode.textContent;
      if (!text || text === this.lastPrefixText) {
        return;
      }
      
      const match = text.match(/(?:\d{1,2}:\d{2}(?::\d{2})?(?:\s*[a-zA-Z]{2})?)\s*UTC(?:[+-]\d{1,2}(?::\d{2})?)?\s*$/);
      if (match) {
        const timeTzText = match[0];
        const prefixText = text.substring(0, text.length - timeTzText.length);
        
        this.lastPrefixText = prefixText;
        prevNode.textContent = prefixText;
        
        if (this.timeTzSpan) {
          this.timeTzSpan.nativeElement.textContent = timeTzText;
        }
      } else {
        this.lastPrefixText = text;
        if (this.timeTzSpan) {
          this.timeTzSpan.nativeElement.textContent = '';
        }
      }
    }
  }
}
